import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0321e33e")

_pushScopeId("data-v-0321e33e")
const _hoisted_1 = { class: "selected" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
    return (_openBlock(), _createBlock("div", {
      class: "preview-small",
      key: card.id,
      style: {width: `${_ctx.fixWidth}px`, height: `${_ctx.fixHeight}px`}
    }, [
      _createVNode(_component_el_image, {
        onClick: ($event: any) => (_ctx.$emit('click-card', card)),
        style: {width: `${_ctx.fixWidth}px`, height: `${_ctx.fixHeight}px`},
        src: card.cardUrl,
        "preview-src-list": [_ctx.cards.map(c => c.cardUrl)]
      }, null, 8, ["onClick", "style", "src", "preview-src-list"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          size: "mini",
          circle: "",
          icon: "el-icon-close",
          onClick: ($event: any) => (_ctx.removeCard(card.id))
        }, null, 8, ["onClick"])
      ])
    ], 4))
  }), 128))
})